import React, {Component} from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'

class ShirtPart extends Component {
    state = {
        selected: this.props.isSelected,
    }

    _handleClick = () => {
        this.setState(({selected}) => {
            return {
                selected: !selected,
            }
        }, () => {
            const {part, afterSelected} = this.props

            afterSelected(part.key, this.state.selected)
        })
    }

    render() {
        const {selected} = this.state
        const {part} = this.props
        const {name, key} = part

        return (
            <div className={className(`ShirtPart col-6 ${key}`, {'selected': selected})}>
                <h4 className='Inner' onClick={this._handleClick}>
                    {name}
                </h4>
            </div>
        )
    }
}

ShirtPart.defaultProps = {
    available: true,
}

ShirtPart.propTypes = {
    available: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    part: PropTypes.object.isRequired,
    afterSelected: PropTypes.func.isRequired,
}

export default ShirtPart
